import { omit } from "lodash-es"
export const DEMAND_CHANGE_FILTER = "DEMAND_CHANGE_FILTER"
export const DEMAND_REMOVE_FILTER_PARAMETER = "DEMAND_REMOVE_FILTER_PARAMETER"
export const DEMAND_RESET_FILTER = "DEMAND_RESET_FILTER"
export const DEMAND_CHANGE_PAGE = "DEMAND_CHANGE_PAGE"
export const DEMAND_CHANGE_SEARCH = "DEMAND_CHANGE_SEARCH"
const INITIAL_STATE = {
  filter: { page: 0, search: "" },
}

export function demandReducer(state = INITIAL_STATE, action) {
  switch (action?.type) {
    case DEMAND_CHANGE_FILTER:
      return {
        ...state,
        filter: { ...state.filter, ...action?.payload, page: 0 },
      }

    case DEMAND_REMOVE_FILTER_PARAMETER:
      return {
        ...state,
        filter: { ...omit(state.filter, action.payload) },
      }

    case DEMAND_RESET_FILTER:
      return {
        ...state,
        filter: { page: 0, search: "" },
      }

    case DEMAND_CHANGE_PAGE:
      return {
        ...state,
        filter: { ...state.filter, page: action?.payload },
      }

    case DEMAND_CHANGE_SEARCH:
      return {
        ...state,
        filter: { ...state.filter, search: action.payload, page: 0 },
      }
    default:
      return state
  }
}
